module.exports = __webpack_public_path__ + "img/guide_2_5.8bb97856.svg";